<template>
  <div class="classdata">
    <div class="title clearfix">
      <span
        style="
          font-size: 18px;
          border-left: 4px solid #409eff;
          padding-left: 20px;
        "
        >班级数据</span
      >
      <el-select
        v-model="value"
        placeholder="请选择班级"
        @change="handleChange"
        size="small"
        class="fr"
      >
        <el-option
          v-for="(item, index) in teachclassdata"
          :key="index"
          :label="item.grade_name+item.class_name+'('+item.subject_name +')'"
          :value="item.grade_id+'/'+item.class_id+'/'+item.subject_id"
        >
        </el-option>
      </el-select>
    </div>
    <!-- <div style="margin-top: 20px; display: flex; justify-content: space-around">
      <div style="text-align: center">
        <div class="space">
          <img src="../../assets/data1.png" alt="" />
          <span>15/20</span>
        </div>
        <div style="font-size: 18px; color: #ff6081">空间</div>
      </div>
      <div style="text-align: center">
        <div class="space">
          <img src="../../assets/data2.png" alt="" />
          <span>15/20</span>
        </div>
        <div style="font-size: 18px; color: #6ad89d">登陆</div>
      </div>
      <div style="text-align: center">
        <div class="space">
          <img src="../../assets/data3.png" alt="" />
          <span>15/20</span>
        </div>
        <div style="font-size: 18px; color: #61aeff">做题</div>
      </div>
    </div> -->

    <div class="ranking clearfix" v-if="list.length">
      <div class="row">
        <div class="color1 listdiv" v-for="(item, index) in list.slice(0,10)" :key="index">
          <span class="list">{{ index + 1 }}</span
          >{{ item.student_name
          }}<span class="fr">{{ item.grade }} 积分</span>
        </div>
      </div>
    </div>
    <div v-else style="margin: 20px 0; text-align: center">暂无班级数据</div>
  </div>
</template>

<script>
import eventBus from "../../api/eventBus";
import URL from "@/api/index";
export default {
  data() {
    return {
      value: "",
      loginInfo: {},
      list: [],
      teachclassdata:[],//任课班级
    };
  },
  components: {},
  created() {},
  mounted() {
    this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.getMasterclass()//获取任课班级列表
  },
  methods: {
    // 获取任课班级列表
    getMasterclass() {
      var that = this;
      var data = { token: JSON.parse(localStorage.getItem("loginInfo")).token };
      this.$post(URL.Getteacherclass, data).then(function (res) {
        that.value = res.result[0].grade_name+res.result[0].class_name+'('+res.result[0].subject_name +')';
        that.teachclassdata = res.result;

        that.handleRank(res.result[0].class_id,res.result[0].subject_id);
      });
    },
    handleRank(e,d) {
      eventBus.$emit("classChange", e);
      var data = {
        classid: e,
        token: this.loginInfo.token,
        subjectid:d,
      };
      this.$post(URL.getsdtclasslog, data).then((res) => {
        // console.log(res);
        if (res.state == 0) {
          var list = res.result;
          var max
          for (var i = 0; i < list.length; i++) {
            for (var j = i; j < list.length; j++) {
              if (list[i].grade < list[j].grade) {
                max = list[j]
                list[j] = list[i]
                list[i] = max
              }
            }
          }
          this.list = list
        }else{
          this.list=[]
        }
      });
    },
    handleChange(n) {
      var a = n.split("/")
      // console.log(a)
      this.handleRank(a[1],a[2]);
    },
  },
};
</script>

<style lang='less' scoped>
.classdata {
  width: 310px;
  padding: 6px 20px 20px;
  background-color: #fff;
  margin-top: 15px;
  border-radius: 8px;
}
.title {
  border-bottom: 1px solid #f4f4f4;
  height: 50px;
  line-height: 50px;
}
.el-select {
  width: 150px !important;
}
.space {
  width: 75px;
  height: 75px;
  display: inline-block;
  // border-radius: 50%;
  font-size: 18px;
  line-height: 75px;
  text-align: center;
  margin-bottom: 10px;
  position: relative;
  color: #fff;
  span {
    position: absolute;
    top: 0;
    left: 20%;
  }
}

.ranking {
  // border-top: 1px solid #f3f3f3;
  margin-bottom: 20px;
  margin-top: 15px;
  padding-top: 10px;
  .row {
    height: 40px;
    line-height: 40px;
    margin-bottom: 5px;
    // border-bottom: 1px dashed #a5a5a5;
  }
  .list {
    // border: 1px solid #f3f3f3;
    border-radius: 50%;
    // background-color: rgb(116, 70, 70);
    padding: 6px 10px;
    margin-right: 26px;
  }
  .listdiv {
    margin-bottom: 15px;
  }
  .color1 {
    color: #ff7e00;
    .list {
      color: #fff;
      background-color: #ff7e00;
    }
  }

  // .color2 {
  //   color: #ff9d3e;
  //   .list {
  //     color: #fff;
  //     background-color: #ff9d3e;
  //   }
  // }
  // .color3 {
  //   color: #ffc184;
  //   .list {
  //     color: #fff;
  //     background-color: #ffc184;
  //   }
  // }
  // .color4 {
  //   color: #adadad;
  //   .list {
  //     color: #fff;
  //     background-color: #adadad;
  //   }
  // }
}
</style>
